import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { AccountClosureReason } from '__generated__/GQL';
import FormField from 'components/_core/form/Field';
import Input from 'components/_core/form/Input';
import Text from 'components/_core/Text';

import Title from '../../../../../components/Title';
import { getFormDefaultValues } from '../../../../helpers';
import locales from './locales';

const OtherOption = () => {
  const { register, reset } = useFormContext();

  /**
   * Entering this section automatically adds the `Other` reason
   * and remove all other reasons.
   */
  useEffect(() => {
    const defaultValues = getFormDefaultValues();

    reset({
      ...defaultValues,
      reasons: new Set([AccountClosureReason.Other]),
    });
  }, [reset]);

  return (
    <>
      <Title>{locales.title}</Title>

      <Text fontSize="font-15" mb="space-40" size="sm">
        {locales.subtitle}
      </Text>

      <FormField hint={locales.hint}>
        <Input
          placeholder={locales.placeholder}
          {...register('otherExplanation', {})}
        />
      </FormField>
    </>
  );
};

export default OtherOption;
